import React, { useState } from "react";
import CommonLayout from "../../layout/CommonLayout";
import CommonMenu from "../../layout/CommonMenu";
import CommonFooter from "../../layout/CommonFooter";
import { Link } from "react-router-dom";

const GNBPURE02004S = () => {

    const [isOpen, setIsOpen] = useState(false); // 드롭다운 메뉴 열림 상태
    const toggleDropdown = (e) => {
        e.preventDefault(); // 기본 동작 방지 (URL 변경 X)
        setIsOpen(!isOpen); // 상태 토글
    };

  return (
	<CommonLayout>
      <CommonMenu />
		<>
		  <div id="contents" className="container">
			<div className="sub-title bg-type02">
			  <h2>제품소개</h2>
			</div>

			<div className="location_wrap">
			  <ul className="depth1">
				<li>
				  <Link to="/">home</Link>
				</li>
				<li>
                    <a href="#none" onClick={toggleDropdown}>
                        기관연계시스템<span></span>
                    </a>
				    <ul className="depth2" style={{ display: isOpen ? "block" : "none" }}>
                        <li>
                            <Link to="/GNBPURE02001S">온라인대출</Link>
                        </li>
                        <li>
                            <Link to="/GNBPURE02002S">스탁론</Link>
                        </li>
                        <li>
                            <Link to="/GNBPURE02003S">NPL</Link>
                        </li>
                        <li>
                            <Link to="/GNBPURE02004S">기관연계시스템</Link>
                        </li>
                        <li>
                            <Link to="/GNBPURE02000S">통합솔루션</Link>
                        </li>
                    </ul>
				</li>
			  </ul>
			</div>

			<div id="cont" className="cont">
			  <div className="inner">
				<h3>기관연계시스템</h3>

                    <article> 
                        <p className="subtitle">통합중계시스템</p>
                        <p className="txt-wrap">
                            자사의 통합중계시스템은 다양한 외부환경과의 인터페이스를 통하여 서비스되는 업무의 특성상 
                            여러 대외 기관의 환경 수용은 물론 업무시스템을 표준화 할 수 있는 인터페이스를 제공할 수 있어야 합니다. 
                            <br/>
                            통합중계시스템은 다양한 외부환경의 모듈화된 연계기능들을 컴포넌트화하여 설계된 시스템으로서, 
                            중계관련 전문 기술자가 아니더라도 일종의 툴 기능에 의해 손쉽게 기관 및 응용시스템 연계관련 작업을 처리 할 수 있어 
                            무엇보다 유지보수성이 용이한 강점을 지니고 있습니다.
                        </p>
                    </article> 
                    <article>
                        <p className="subtitle">시스템 구성도</p>
                        <div className="modal-zoom mo">
                            {/* <button type="button" className="btn-sm btn-info" onclick="openModal()">이미지 확대하기</button> */}
                        </div>
                        <img src="/asset/img/subC/img_product_02_2.png" alt="통합중계시스템의 구성도 이미지"/>
                    </article>

                    <article className="pc">
					<p className="subtitle">주요기능 및 제공서비스</p>
					<div className="table-type table-col">
						<table>
							<caption>통합중계시스템의 주요기능 및 제공서비스 안내표</caption>
							<colgroup>
								<col style={{width: "25%"}}/>
								<col style={{width: "25%"}}/>
								<col style={{width: "25%"}}/>
								<col style={{width: "*"}}/>
							</colgroup>
							<thead>
								<tr>
									<th scope="col">개인 스마트뱅킹 서비스</th>
									<th scope="col">온라인대출 서비스</th>
									<th scope="col">중소기업 인터넷뱅킹 서비스</th>
									<th scope="col">펌뱅킹 서비스</th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td>
										<ul className="bul-dot">
											<li>조회 및 이체 서비스</li>
											<li>대출관련 서비스</li>
											<li>신규/해약 서비스</li>
											<li>사고신고 서비스</li>
											<li>고객정보 및 부가서비스</li>
										</ul>
									</td>
									<td>
										<ul className="bul-dot">
											<li>본인확인: 인증서, 가드, 휴대폰</li>
											<li>대출한도조회 서비스</li>
											<li>대출신청 서비스</li>
											<li>CSS</li>
											<li>대출결과조회 서비스</li>
											<li>대출지급신청 서비스</li>
											<li>거래내역조회 서비스</li>
										</ul>
									</td>
									<td>
										<ul className="bul-dot">
											<li>조회 서비스</li>
											<li>대량이체 서비스</li>
											<li>사고신고 서비스</li>
										</ul>
									</td>
									<td>
										<ul className="bul-dot">
											<li>조회/송금/관리 서비스</li>
											<li>실적/수수료 관련 서비스</li>
											<li>대량이체 서비스</li>
											<li>정산 서비스</li>
										</ul>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</article>
	
				<article className="mo">
					<p className="subtitle">주요기능 및 제공서비스</p>
					<div className="table-type table-row">
						<table>
							<caption>통합중계시스템의 주요기능 및 제공서비스 안내표</caption>
							<colgroup>
								<col style={{width: "36%"}}/>
								<col style={{width: "*"}}/>
							</colgroup>
							<tbody>
								<tr>
									<th scope="row">개인 스마트뱅킹 서비스</th>
									<td>
										<ul className="bul-dot">
											<li>조회 및 이체 서비스</li>
											<li>대출관련 서비스</li>
											<li>신규/해약 서비스</li>
											<li>사고신고 서비스</li>
											<li>고객정보 및 부가서비스</li>
										</ul>
									</td>
								</tr>
								<tr>
									<th scope="row">온라인대출 서비스</th>
									<td>
										<ul className="bul-dot">
											<li>본인확인: 인증서, 가드, 휴대폰</li>
											<li>대출한도조회 서비스</li>
											<li>대출신청 서비스</li>
											<li>CSS</li>
											<li>대출결과조회 서비스</li>
											<li>대출지급신청 서비스</li>
											<li>거래내역조회 서비스</li>
										</ul>
									</td>
								</tr>
								<tr>
									<th scope="row">중소기업 인터넷뱅킹 서비스</th>
									<td>
										<ul className="bul-dot">
											<li>조회 서비스</li>
											<li>대량이체 서비스</li>
											<li>사고신고 서비스</li>
										</ul>
									</td>
								</tr>
								<tr>
									<th scope="row">펌뱅킹 서비스</th>
									<td>
										<ul className="bul-dot">
											<li>조회/송금/관리 서비스</li>
											<li>실적/수수료 관련 서비스</li>
											<li>대량이체 서비스</li>
											<li>정산 서비스</li>
										</ul>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</article>
	
				<article className="pc">
					<p className="subtitle">특징</p>
					<div className="table-type table-col">
						<table>
							<caption>통합중계시스템의 특징 안내표</caption>
							<colgroup>
								<col style={{width: "20%"}}/>
								<col style={{width: "20%"}}/>
								<col style={{width: "19%"}}/>
								<col style={{width: "20%"}}/>
								<col style={{width: "*"}}/>
							</colgroup>
							<thead>
								<tr>
									<th scope="col">전체 시스템의 통합화</th>
									<th scope="col">전문 통합/표준화 전문관리</th>
									<th scope="col">모니터링 기능</th>
									<th scope="col">객체 지향의 개발환경 지원</th>
									<th scope="col">개발 및 운영, 유지보수 용이</th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td>전체 시스템을 통합화하여 HOST와의 단일 연결 채널역할을 하며, 각종 응용시스템에서 기본 Application만 두고 통합중계시스템에서 대부분의 Business Logic을 처리하여 줌으로써 응용시스템의 부하를 최소화 함</td>
									<td>전문관리 솔루션을 적용하여 다양한 기관과 시스템의 서로 다른 전문을 통합/표준화 및 기존 HOST와 동일한 전문으로 변환하여 줌으로써, 기존 HOST의 Process 변경 없이 대외연계업무 구현 용이</td>
									<td>전문 모니터링 솔루션을 적용, 모니터링 기능 제공으로 안정적인 시스템 운영 가능</td>
									<td>거래전문의 각각의 Component로 구성하고 이것을 Datebase화 하여 관리함으로써 객체지향의 개발환경 지원</td>
									<td>전문매핑툴을 사용하여 개발 사용자가 여러 대외기관연계 업무 개발 시, 필요정보의 입력만으로도 전문관리 및 자료집계, 대사, 정산의 모든 과정이 자동 구현됨으로 개발 및 운영, 유지보수가 매우 용이</td>
								</tr>
							</tbody>
						</table>
					</div>
				</article>
	
				<article className="mo">
					<p className="subtitle">특징</p>
					<div className="table-type table-row">
						<table>
							<caption>통합중계시스템의 특징 안내표</caption>
							<colgroup>
								<col style={{width: "36%"}}/>
								<col style={{width: "*"}}/>
							</colgroup>
							<tbody>
								<tr>
									<th scope="row">전체 시스템의 통합화</th>
									<td>전체 시스템을 통합화하여 HOST와의 단일 연결 채널역할을 하며, 각종 응용시스템에서 기본 Application만 두고 통합중계시스템에서 대부분의 Business Logic을 처리하여 줌으로써 응용시스템의 부하를 최소화 함</td>
								</tr>
								<tr>
									<th scope="row">전문 통합/표준화 전문관리</th>
									<td>전문관리 솔루션을 적용하여 다양한 기관과 시스템의 서로 다른 전문을 통합/표준화 및 기존 HOST와 동일한 전문으로 변환하여 줌으로써, 기존 HOST의 Process 변경 없이 대외연계업무 구현 용이</td>
								</tr>
								<tr>
									<th scope="row">모니터링 기능</th>
									<td>전문 모니터링 솔루션을 적용, 모니터링 기능 제공으로 안정적인 시스템 운영 가능</td>
								</tr>
								<tr>
									<th scope="row">객체 지향의 개발환경 지원</th>
									<td>거래전문의 각각의 Component로 구성하고 이것을 Datebase화 하여 관리함으로써 객체지향의 개발환경 지원</td>
								</tr>
								<tr>
									<th scope="row">개발 및 운영, 유지보수 용이</th>
									<td>전문매핑툴을 사용하여 개발 사용자가 여러 대외기관연계 업무 개발 시, 필요정보의 입력만으로도 전문관리 및 자료집계, 대사, 정산의 모든 과정이 자동 구현됨으로 개발 및 운영, 유지보수가 매우 용이</td>
								</tr>
							</tbody>
						</table>
					</div>
				</article>
			  </div>
			</div>
		  </div>

          {/* <div className="modal-wrap modal-zoom">
            <div>
                <div className="modal-top">
                    <a type="button" className="btn-close" onclick="closeModal()">닫기</a>
                </div>
                <div className="modal-cont">
                    <p>
                        <img src="/asset/img/subC/img_product_02_2.png" alt="통합중계시스템의 구성도 이미지"/>
                    </p>
                    <div className="btn-wrap">
                        <button type="button" className="btn-m btn-primary" onclick="closeModal()">확인</button>
                    </div>
                </div>
            </div>
	      </div> */}
          
		  <CommonFooter />
		</>
	</CommonLayout>
  );
};

export default GNBPURE02004S;
